import React, { useRef } from 'react'
import { Link, graphql } from 'gatsby'
import Sticky from 'react-stickynode'
import Img from 'gatsby-image'
import { blogUrl } from '../util/constants'
import Topbar from '../components/topbar'
import NewsletterForm from '../components/newsletter-form'
import StartupCarousel from '../components/startup-carousel'

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

const formatDate = (date) => {
  const [ymd, _] = date.split('T')
  const [y, m, d] = ymd.split('-')

  return `${months[parseInt(m) - 1]} ${d}`
}

const IndexPage = ({ data, showMenu }) => {
  const posts = data && data.allIcBlog.edges
  const post = posts && posts[0]
  const companies = data?.carouselStartups?.edges
  return (
    <div>
      <Sticky enabled={true} top={0} innerZ={100}>
        <Topbar current={''} showMenu={showMenu} />
      </Sticky>

      <header>
        <div className="section-content">
          <h1>
            Agile.
            <br />
            Fierce.
            <br />
            Relentless.
          </h1>
          <h5>
            We are the honeybadgers
            <br />
            of venture
          </h5>
          <h3>$200B in value and just getting started</h3>
          <div className="arrow-links">
            <Link to="/who/">
              Who we are <span className="arrow" />
            </Link>
            <Link to="/startups/">
              Our startups <span className="arrow" />
            </Link>
          </div>
        </div>
      </header>
      <section className="portfolio">
        <div className="section-content">
          <h1>Our Startups</h1>
        </div>
        <StartupCarousel companies={companies} />
      </section>

      <section className="paws">
        <div className="section-content">
          <h2>We get our paws dirty</h2>
          <h4>Started by founders, for founders</h4>
          <div className="arrow-links">
            <Link to="/how/">
              How we can help <span className="arrow" />
            </Link>
            <Link to="/interests/">
              What we invest in <span className="arrow" />
            </Link>
          </div>
        </div>
      </section>

      <section className="lead">
        <div className="section-content">
          <h2>We lead, early.</h2>
          <a name="newsletter" />
          <NewsletterForm />
        </div>
      </section>
      <section className="blog">
        <div className="section-content">
          <a href={blogUrl} className="blog-link">
            Read more on our blog
            <span className="arrow arrow-red" />
          </a>
          {post && (
            <article key={post.node.id}>
              <img
                src={`${post.node.thumbnail}`}
                alt={post.node.title}
                width="676"
              />
              <div className="published">{formatDate(post.node.date)}</div>
              <div className="title">
                <a href={`${post.node.link}`} target="_blank">
                  {post.node.title}
                </a>
              </div>
              <div className="byline">by {post.node.author}</div>
            </article>
          )}
        </div>
      </section>
    </div>
  )
}

export default IndexPage

export const query = graphql`
  query IndexQuery {
    allIcBlog(limit: 1, sort: { fields: [date], order: DESC }) {
      edges {
        node {
          id
          title
          link
          author
          slug
          date
          thumbnail
        }
      }
    }

    carouselStartups: allStrapiStartup(
      filter: { carousel_logo: { id: {ne: null} } }
      sort: { order: [ASC, ASC], fields: [display_order, name] }
    ) {
      edges {
        node {
          name
          url
          display_on_homepage
          carousel_logo {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid_tracedSVG
                ...GatsbyImageSharpFluidLimitPresentationSize
              }
            }
          }
        }
      }
    }
  }
`
